import {SimpleForm} from 'react-admin';

const SimpleFormMod = props => {
    return (<SimpleForm {...props} ></SimpleForm>);
};

export default SimpleFormMod;